// AccountSidebar.jsx
import React from "react";
import { Link } from "react-router-dom";

const AccountSidebar = ({
  dashView,
  setDashView,
  userData,
  initials,
  ordersCount,
  wishlistCount,
  cartCount,
  onLogout,
}) => {
  // All items now use `view` — everything renders inside the dashboard
  const navItems = [
    { id: "overview",  icon: "ph-squares-four",  label: "Overview",             view: "overview" },
    { id: "orders",    icon: "ph-package",        label: "My Orders",            view: "orders",   count: ordersCount },
    { id: "wishlist",  icon: "ph-heart",          label: "Wishlist",             view: "wishlist", count: wishlistCount },
    { id: "cart",      icon: "ph-shopping-cart",  label: "Shopping Cart",        view: "cart",     count: cartCount },

    // New delivery address button
    { id: "delivery-address", icon: "ph-map-pin", label: "Add Delivery Address", view: "delivery-address" },

    { id: "settings",  icon: "ph-gear",           label: "Settings",             view: "settings" },
  ];

  return (
    <aside className="ap-side">
      {/* Brand */}
      <div className="ap-side-brand">
        <div className="ap-side-brand-icon">
          <i className="ph ph-storefront" />
        </div>
        <span className="ap-side-brand-name">MyStore</span>
      </div>

      {/* Nav */}
      <nav className="ap-side-nav">
        <div className="ap-side-nav-label">Main</div>

        {navItems.map((item) => (
          <div
            key={item.id}
            className={`ap-nav-link${dashView === item.view ? " active" : ""}`}
            onClick={() => setDashView(item.view)}
          >
            <span className="ap-nav-link-left">
              <i className={`ph ${item.icon}`} style={{ fontSize: 16 }} />
              {item.label}
            </span>
            {item.count > 0 && (
              <span className="ap-nav-count">{item.count}</span>
            )}
          </div>
        ))}

        <div className="ap-side-divider" />
        <div className="ap-side-nav-label">Help</div>
        <Link to="/contact" className="ap-nav-link">
          <span className="ap-nav-link-left">
            <i className="ph ph-chat-circle" style={{ fontSize: 16 }} />
            Contact Support
          </span>
        </Link>
        <Link to="/live-chat" className="ap-nav-link">
          <span className="ap-nav-link-left">
            <i className="ph ph-chat-circle" style={{ fontSize: 16 }} />
            Live Chat
          </span>
        </Link>
      </nav>

      {/* User card */}
      <div className="ap-side-user">
        <div className="ap-avatar">{initials}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="ap-user-name">{userData?.name || "Loading…"}</div>
          <div className="ap-user-email">{userData?.email || ""}</div>
        </div>
        <button className="ap-logout-ico" onClick={onLogout} title="Sign out">
          <i className="ph ph-sign-out" />
        </button>
      </div>
    </aside>
  );
};

export default AccountSidebar;